
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/background-changer",
      function () {
        return require("private-next-pages/background-changer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/background-changer"])
      });
    }
  